export interface TamBaseResultaat {
  type: 'TamSuccesResultaatDto' | 'TamValidatieFoutResultaatDto';
}

export interface TamSuccesResultaat extends TamBaseResultaat {
  type: 'TamSuccesResultaatDto';
  aanTeMakenBewegingen: Array<number>;
  opTeHeffenBewegingen: Array<number>;
  teWijzigenBewegingen: Array<number>;
  tamDienstenZonderEenheid: number;
  tamDienstenZonderUitloop: number;
}

export enum Bestandsvalidatiefouttype {
  LEEG_BESTAND = 'LEEG_BESTAND',
  TE_LANGE_REGEL = 'TE_LANGE_REGEL',
  FORMAT_FOUT = 'FORMAT_FOUT',
}

export interface TamValidatieFoutResultaat extends TamBaseResultaat {
  type: 'TamValidatieFoutResultaatDto';
  bewegingenMetValidatieFouten: Array<number>;
  bestandsvalidatiefouten: Array<Bestandsvalidatiefouttype>;
}

export type TamResultaat = TamSuccesResultaat | TamValidatieFoutResultaat;
